import { format } from 'pretty-format'

export function _unionTypeDescription(...vals: string[]): string {
  return vals.map(val => format(val)).join(' | ')
}
